import {
  FormFieldBlueprint,
  createFormField,
} from '@backstage/plugin-scaffolder-react/alpha';
import { RegionPicker } from './RegionPickerExtension';
import { validateRegion } from './validateRegion';

export const RegionPickerFieldExtension = FormFieldBlueprint.make({
  name: 'RegionPicker',
  params: {
    field: async () =>
      createFormField({
        name: 'RegionPicker',
        component: RegionPicker,
        validation: validateRegion,
      }),
  },
});
